import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
  Progress,
  NavLink,
  NavItem,
  Button,
  CardTitle,
  FormFeedback,
  FormText
} from "reactstrap";
import classnames from "classnames";
import { Link, Navigate } from "react-router-dom";
import Async from 'react-select/async';
import { useEffect } from "react";
import {
  clearUpdateUserError,
  getFilteredStatesForAsyncSelect,
  updateUser
} from "../../store/actions";
import {
  closeCreateZoneModal,
  getAssignableZonesForAsyncSelect,
  openCreateZoneModal
} from "../../store/zones/actions";
import { connect } from "react-redux";
import Message from "../../CommonData/Data/Message";
import {
  clearForm,
  updateForm
} from "../../store/form/actions";
import FormValidator from "../../helper/formValidator";
import {
  ORGANIZATION_ADMIN,
  RETAILER,
  ROLE_PERMISSION_ORG_ADMIN,
  SUPER_ADMIN
} from "../../store/users/role.constants";
import AddZone from "../Zones/AddZone";
import VWModel from "../../components/vwModal/vwModal";
import VWLoading from "../../components/vwLoading/vwLoading";
import Select from 'react-select';

const customStyle = {
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#0bb197',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'white',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'white',
    ':hover': {
      backgroundColor: '#ff3d60',
      color: 'white',
    },
  }),
}

const FormWizard = (props) => {

  const { userDetails, errorMessage, form, isSuccess, currentProfile, isPending } = props;
  const [activeTabwiz, setoggleTabwiz] = useState(1);
  const [passedStepswiz, setpassedStepswiz] = useState([1]);
  const [user, setUser] = useState("");
  const [selected_zone, setSelectedZone] = useState("");
  const [selected_state, setSelectedState] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [selectedRolePermission, setSelectedRolePermission] = useState([]);

  const currentRole = currentProfile.roles && currentProfile.roles.length > 0 && (currentProfile.roles[0])
  const isOrgAdmin = currentRole && currentRole.roleKey === ORGANIZATION_ADMIN;
  const isRetailer = currentRole && currentRole.roleKey === RETAILER;
  const isSuperAdmin = currentRole && currentRole.roleKey === SUPER_ADMIN;

  useEffect(() => {
    const { updateForm, clearForm, clearUpdateUserError } = props || {};
    if (userDetails) {
      const selected_zone = {
        label: userDetails.zone,
        value: userDetails.zone,
      };
      const selected_state = {
        label: userDetails.state,
        value: userDetails.state,
      };
      setUser({
        ...userDetails,
        selected_zone: selected_zone,
        selected_state: selected_state,
      });
      setSelectedZone(selected_zone);
      setSelectedState(selected_state);
      if (isSuperAdmin) {
        const rolesSelected = userDetails && userDetails.rolePermissions;
        const rolesArr = rolesSelected && rolesSelected.split(',');
        const filteredRole = rolesArr && rolesArr.flatMap((i) => ROLE_PERMISSION_ORG_ADMIN && ROLE_PERMISSION_ORG_ADMIN.filter((role) => i && i.trim() === role.value));
        if ((filteredRole && filteredRole.length) > 0) {
          setSelectedRolePermission(filteredRole);
        }
      }

      updateForm({
        formAddUser: {
          formAddUser1: {
            ...userDetails,
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            displayName: userDetails.displayName,
            mobileNumber: userDetails.mobileNumber,
            email: userDetails.email,
          },
          formAddUser2: {
            addressLine1: userDetails.addressLine1,
            addressLine2: userDetails.addressLine2,
            selected_zone: selected_zone,
            selected_state: selected_state,
            district: userDetails.district,
            town: userDetails.town,
            zip: userDetails.zip,
          },
          formAddUser3: {
            isActive: userDetails.isActive,
            isEnabled: userDetails.isEnabled,
            isLocked: userDetails.isLocked,
            rolePermissions: userDetails.rolePermissions,
          },
          errors1: {},
          errors2: {},
          errors3: {}
        }
      })
    }
    clearUpdateUserError();
    return () => {
      clearUpdateUserError();
      clearForm();
    }
  }, [userDetails]);

  //--------------------------TAB-1--------------------------------------------------------------
  const handleInputChange1 = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
    let result = {};
    if (name === 'mobileNumber') {
      const contactNumberRegex = /^\d{10}$/;
      result = {
        isValid: contactNumberRegex.test(value),
        message: 'Enter valid mobile number',
      };
    }
    else {
      result = FormValidator.validate(event.target);
    }

    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser1: {
          ...form && form.formAddUser && form.formAddUser.formAddUser1,
          [name]: value
        },
        errors1: {
          ...form && form.formAddUser.errors1,
          [name]: result.isValid ? null : result.message,
        }
      }
    });
  }

  //--------------------------TAB-2--------------------------------------------------------------
  const handleInputChange2 = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser2: {
          ...form.formAddUser.formAddUser2,
          [name]: value
        },
        errors2: {
          ...form && form.formAddUser.errors2,
          [name]: null,
        }
      }
    });
  }

  const handleLoadZones = (inputValue, callback) => {
    props.getAssignableZonesForAsyncSelect(inputValue, callback);
  };
  const handleRefreshZones = () => {
    setRefresh(refresh + 1)
  };

  const handleLoadStates = (inputValue, callback) => {
    props.getFilteredStatesForAsyncSelect(inputValue, callback);
  };

  const handleStateChange = (value) => {
    setUser({ ...user, selected_state: value });
    setSelectedState(value);
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser2: {
          ...form.formAddUser.formAddUser2,
          selected_state: value ? value : "",
        },
        errors2: {
          ...form && form.formAddUser.errors2,
          selected_state: null,
        }
      }
    });
  }

  const handleZoneChange = (value) => {
    setUser({ ...user, selected_zone: value })
    setSelectedZone(value);
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser2: {
          ...form.formAddUser.formAddUser2,
          selected_zone: value ? value : "",
        },
        errors2: {
          ...form && form.formAddUser.errors2,
          selected_zone: null,
        }
      }
    });
  }
  const handleOpenCreateZone = () => {
    const { openCreateZoneModal } = props;
    openCreateZoneModal();
  };

  const handleClose = () => {
    const { closeCreateZoneModal } = props;
    closeCreateZoneModal();
  };

  //--------------------------TAB-3--------------------------------------------------------------

  const handleNotificationStatusChange = () => {
    setUser({ ...user, isActive: !user.isActive });
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser3: {
          ...form.formAddUser.formAddUser3,
          isActive: !user.isActive
        },
        errors3: {
          ...form && form.formAddUser.errors3,
          isActive: null,
        }
      }
    });
  };
  const handleActivationStatusChange = () => {
    setUser({ ...user, isEnabled: !user.isEnabled });
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser3: {
          ...form.formAddUser.formAddUser3,
          isEnabled: !user.isEnabled
        },
        errors3: {
          ...form && form.formAddUser.errors3,
          isEnabled: null,
        }
      }
    });
  };

  const handleLockStatusChange = () => {
    setUser({ ...user, isLocked: !user.isLocked });
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser3: {
          ...form.formAddUser.formAddUser3,
          isLocked: !user.isLocked
        },
        errors3: {
          ...form && form.formAddUser.errors3,
          isLocked: null,
        }
      }
    });
  };
  const handleRolePermission = (options) => {
    setSelectedRolePermission(options);
    const selectedRoles = options && options.map((i) => i.value);
    const roleString = selectedRoles.join(",")
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser3: {
          ...form.formAddUser.formAddUser3,
          rolePermissions: roleString,
        },
        errors3: {
          ...form && form.formAddUser.errors3,
          rolePermissions: null,
        }
      }
    });
  }
  //---------------------VALIDATION & PAGE NAVIGATION-----------------------------------------------------------
  const toggleTabwiz = (tab) => {
    const { formAddUser } = form || {};
    const { formAddUser1, formAddUser2, errors1 } = formAddUser || {};
    const { firstName, lastName, displayName, mobileNumber, email } = formAddUser1 || {};
    const { addressLine1, selected_zone, selected_state, district, zip, town } = formAddUser2 || {};

    let errors = {};
    const currentErrors1 = {};
    const currentErrors2 = {};

    //---------------------TAB-1-----------------------------------------------------------
    if (activeTabwiz === 1) {
      if (!firstName) {
        currentErrors1.firstName = "First name is required"
      }
      if (!lastName) {
        currentErrors1.lastName = "Last name is required"
      }
      if (!displayName) {
        currentErrors1.displayName = "Display name is required"
      }
      if (!mobileNumber) {
        currentErrors1.mobileNumber = "Mobile number is required"
      }
      if (errors1 && errors1.mobileNumber) {
        currentErrors1.mobileNumber = "Enter valid mobile number"
      }
      if (!email) {
        currentErrors1.email = "Email is required"
      }
      if (errors1 && errors1.email) {
        currentErrors1.email = "Enter valid email"
      }
      props.updateForm({
        formAddUser: {
          ...formAddUser,
          formAddUser1: {
            ...form.formAddUser.formAddUser1,
          },
          errors1: currentErrors1,
        }
      })

      errors = currentErrors1;
    }

    //---------------------TAB-2-----------------------------------------------------------
    if (activeTabwiz === 2) {
      if (!addressLine1 && isOrgAdmin) {
        currentErrors2.addressLine1 = "Address is required"
      }
      if (!selected_zone && isOrgAdmin) {
        currentErrors2.selected_zone = "Zone is required"
      }
      if (!selected_state && isOrgAdmin) {
        currentErrors2.selected_state = "State is required"
      }
      if (!town && isOrgAdmin) {
        currentErrors2.town = "Town is required"
      }
      if (!district && isOrgAdmin) {
        currentErrors2.district = "District is required"
      }
      if (!zip && isOrgAdmin) {
        currentErrors2.zip = "Zip is required"
      }
      if (((zip && zip.length) !== 6) && zip) {
        currentErrors2.zip = "Invalid zip is required"
      }
      props.updateForm({
        formAddUser: {
          ...formAddUser,
          formAddUser2: {
            ...form.formAddUser.formAddUser2,
          },
          errors2: currentErrors2,
        }
      })

      errors = currentErrors2
    }

    if (Object.keys(errors).length === 0) {
      if (activeTabwiz !== tab) {
        var modifiedSteps = [...passedStepswiz, tab];
        if (isOrgAdmin) {
          if (tab >= 1 && tab <= 4) {
            setoggleTabwiz(tab);
            setpassedStepswiz(modifiedSteps);
          }
        }
        else {
          if (tab >= 1 && tab <= 3) {
            setoggleTabwiz(tab);
            setpassedStepswiz(modifiedSteps);
          }
        }
      }
    }
    else {
      if (activeTabwiz > tab) {
        var modifiedSteps = [...passedStepswiz, tab];
        if (isOrgAdmin) {
          if (tab >= 1 && tab <= 4) {
            setoggleTabwiz(tab);
            setpassedStepswiz(modifiedSteps);
          }
        }
        else {
          if (tab >= 1 && tab <= 3) {
            setoggleTabwiz(tab);
            setpassedStepswiz(modifiedSteps);
          }
        }
      }
    }
  }

  //--------------------------UPDATE FORM SUBMISSION--------------------------------------------------------------
  const handleSubmit = () => {
    const { updateUser } = props;
    const data = {
      ...form.formAddUser.formAddUser1,
      ...form.formAddUser.formAddUser2,
      ...form.formAddUser.formAddUser3,
    }
    updateUser(data);

  };
  return isSuccess ? (<Navigate to={`/userlist/details/${user.id}`} />) : (
    <React.Fragment>
      <div className="page-content">
        <Row>
          <Col lg="12">
            <Card>
              <CardTitle className='p-2 d-flex justify-content-between align-items-center border-bottom border-secondary'>
                <h5 className="fw-bold">EDIT USER</h5>
                <Link to={`/userlist/details/${user.id}`} className="text-dark">
                  <i className="mdi mdi-close fs-2"></i>
                </Link>
              </CardTitle>
              <CardBody>
                {errorMessage && (
                  <div className="w-50">
                    <Message
                      type="danger"
                      defaultMessage={errorMessage}
                      baseClassName="alert"
                    />
                  </div>
                )}
                <div id="progrss-wizard" className="twitter-bs-wizard">
                  <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                    <NavItem className={classnames({ active: activeTabwiz === 1 })}>
                      <NavLink
                        className={(classnames({ active: activeTabwiz === 1 }))}
                        onClick={() => toggleTabwiz(1)}
                      >
                        <span className="step-number">01</span>
                        <span className="step-title" style={{ paddingLeft: "10px" }}>User Details</span>
                      </NavLink>
                    </NavItem>
                    {isOrgAdmin && <NavItem className={classnames({ active: activeTabwiz === 2 })}>
                      <NavLink
                        className={(classnames({ active: activeTabwiz === 2 }))}
                        onClick={() => toggleTabwiz(2)}
                      >
                        <span className="step-number">02</span>
                        <span className="step-title" style={{ paddingLeft: "10px" }}>Communication Details</span>
                      </NavLink>
                    </NavItem>}
                    <NavItem className={isOrgAdmin ? classnames({ active: activeTabwiz === 3 }) : classnames({ active: activeTabwiz === 2 })}>
                      <NavLink
                        className={isOrgAdmin ? classnames({ active: activeTabwiz === 3 }) : classnames({ active: activeTabwiz === 2 })}
                        onClick={() => {
                          isOrgAdmin ? toggleTabwiz(3) : toggleTabwiz(2);
                        }}
                      >
                        <span className="step-number">{isOrgAdmin ? "03" : "02"}</span>
                        <span className="step-title" style={{ paddingLeft: "10px" }}>Status & Permissions Details</span>
                      </NavLink>
                    </NavItem>
                    <NavItem className={isOrgAdmin ? classnames({ active: activeTabwiz === 4 }) : classnames({ active: activeTabwiz === 3 })}>
                      <NavLink
                        className={isOrgAdmin ? classnames({ active: activeTabwiz === 4 }) : classnames({ active: activeTabwiz === 3 })}
                        onClick={() => {
                          isOrgAdmin ? toggleTabwiz(4) : toggleTabwiz(3);
                        }}                      >
                        <span className="step-number">{isOrgAdmin ? "04" : "03"}</span>
                        <span className="step-title" style={{ paddingLeft: "10px" }}>Confirm Details</span>
                      </NavLink>
                    </NavItem>
                  </ul>
                  <div id="bar" className="my-4">
                    <Progress
                      value={25 * activeTabwiz}
                      color="success"
                      animated
                    />
                  </div>
                  <TabContent activeTab={activeTabwiz} className="twitter-bs-wizard-tab-content">
                    <TabPane tabId={1}>
                      <Form>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label htmlFor="basicpill-firstname-input1">
                                First Name
                              </Label><span className="text-danger">*</span>
                              <Input
                                autoFocus
                                id="basicpill-firstname-input1"
                                className="form-control"
                                type="text"
                                name="firstName"
                                placeholder="Enter first name"
                                onChange={handleInputChange1}
                                value={user.firstName}
                                invalid={form && form.formAddUser
                                  && form.formAddUser.errors1 &&
                                  form.formAddUser.errors1.firstName}
                              />
                              <FormFeedback>
                                {form && form.formAddUser
                                  && form.formAddUser.errors1 &&
                                  form.formAddUser.errors1.firstName}
                              </FormFeedback>
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label htmlFor="basicpill-lastname-input2">
                                Last Name
                              </Label><span className="text-danger">*</span>
                              <Input
                                id="basicpill-lastname-input2"
                                className="form-control"
                                type="text"
                                name="lastName"
                                placeholder="Enter last name"
                                onChange={handleInputChange1}
                                value={user.lastName}
                                invalid={form && form.formAddUser
                                  && form.formAddUser.errors1 &&
                                  form.formAddUser.errors1.lastName}
                              />
                              <FormFeedback>
                                {form && form.formAddUser
                                  && form.formAddUser.errors1 &&
                                  form.formAddUser.errors1.lastName}
                              </FormFeedback>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label htmlFor="basicpill-phoneno-input3">
                                Display Name
                              </Label><span className="text-danger">*</span>
                              <Input
                                id="basicpill-phoneno-input3"
                                className="form-control"
                                type="text"
                                name="displayName"
                                placeholder="Enter display name"
                                onChange={handleInputChange1}
                                value={user.displayName}
                                invalid={form && form.formAddUser
                                  && form.formAddUser.errors1 &&
                                  form.formAddUser.errors1.displayName}
                              />
                              <FormFeedback>
                                {form && form.formAddUser
                                  && form.formAddUser.errors1 &&
                                  form.formAddUser.errors1.displayName}
                              </FormFeedback>
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label htmlFor="basicpill-address-input1">
                                Mobile Number
                              </Label><span className="text-danger">*</span>
                              <Input
                                id="basicpill-email-input4"
                                className="form-control"
                                type="text"
                                name="mobileNumber"
                                placeholder="Enter mobile number"
                                onChange={handleInputChange1}
                                value={user.mobileNumber}
                                invalid={form && form.formAddUser
                                  && form.formAddUser.errors1 &&
                                  form.formAddUser.errors1.mobileNumber}
                              />
                              <FormFeedback>
                                {form && form.formAddUser
                                  && form.formAddUser.errors1 &&
                                  form.formAddUser.errors1.mobileNumber}
                              </FormFeedback>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="12">
                            <div className="mb-3">
                              <Label htmlFor="basicpill-email-input4">
                                Email
                              </Label><span className="text-danger">*</span>
                              <Input
                                id="basicpill-email-input4"
                                className="form-control"
                                type="email"
                                name="email"
                                placeholder="Enter Email ID"
                                onChange={handleInputChange1}
                                value={user.email}
                                disabled
                              />
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </TabPane>
                    {isOrgAdmin && <TabPane tabId={2}>
                      <div>
                        <Form>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-pancard-input5">
                                  Address Line1
                                </Label><span className="text-danger">*</span>
                                <Input
                                  id="basicpill-pancard-input5"
                                  className="form-control"
                                  type="textarea"
                                  name="addressLine1"
                                  placeholder="Enter Address"
                                  onChange={handleInputChange2}
                                  disabled={!isOrgAdmin}
                                  value={user.addressLine1}
                                  invalid={form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.addressLine1}
                                />
                                <FormFeedback>
                                  {form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.addressLine1}
                                </FormFeedback>
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-pancard-input5">
                                  Address Line2
                                </Label>
                                <Input
                                  id="basicpill-pancard-input5"
                                  className="form-control"
                                  type="textarea"
                                  name="addressLine2"
                                  placeholder="Enter Address"
                                  onChange={handleInputChange2}
                                  disabled={!isOrgAdmin}
                                  value={user.addressLine2}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <div className="d-flex justify-content-between">
                                  <Label htmlFor="basicpill-address-input12">
                                    Zone<span className="text-danger">*</span>
                                  </Label>
                                  <div>
                                    {(isOrgAdmin || isSuperAdmin) &&
                                      <Link
                                        type="button"
                                        className="mb-1"
                                        onClick={handleOpenCreateZone}
                                      >
                                        Add Zone
                                      </Link>
                                    }
                                    <Button
                                      color='link'
                                      size='sm'
                                      className="ms-2"
                                      onClick={handleRefreshZones}
                                    >
                                      <i class="fas fa-sync-alt"></i>
                                    </Button>
                                  </div>
                                </div>
                                <Async
                                  key={refresh}
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: (form && form.formAddUser
                                        && form.formAddUser.errors2 &&
                                        form.formAddUser.errors2.selected_zone) ? '#ff3d60' : "#CED4DA"
                                    })
                                  }}
                                  name="selected_zone"
                                  placeholder="Select Zone"
                                  defaultOptions
                                  menuPortalTarget={document.body}
                                  loadOptions={handleLoadZones}
                                  onChange={handleZoneChange}
                                  isDisabled={!isOrgAdmin}
                                  value={selected_zone}
                                />
                                {(form && form.formAddUser
                                  && form.formAddUser.errors2 &&
                                  form.formAddUser.errors2.selected_zone) &&
                                  <FormText sx={{ marginLeft: "10px" }}>
                                    <div className="text-danger">
                                      {form && form.formAddUser
                                        && form.formAddUser.errors2 &&
                                        form.formAddUser.errors2.selected_zone}
                                    </div>
                                  </FormText>
                                }
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-servicetax-input8">
                                  State
                                </Label><span className="text-danger">*</span>
                                <Async
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: (form && form.formAddUser
                                        && form.formAddUser.errors2 &&
                                        form.formAddUser.errors2.selected_state) ? '#ff3d60' : "#CED4DA"
                                    })
                                  }}
                                  key="selected_state"
                                  id="selected_state"
                                  name="selected_state"
                                  placeholder="Select State"
                                  //cacheOptions
                                  defaultOptions
                                  menuPortalTarget={document.body}
                                  loadOptions={handleLoadStates}
                                  onChange={handleStateChange}
                                  isDisabled={!isOrgAdmin}
                                  value={selected_state}
                                />
                                {(form && form.formAddUser
                                  && form.formAddUser.errors2 &&
                                  form.formAddUser.errors2.selected_state) &&
                                  <FormText sx={{ marginLeft: "10px" }}>
                                    <div className="text-danger">
                                      {form && form.formAddUser
                                        && form.formAddUser.errors2 &&
                                        form.formAddUser.errors2.selected_state}
                                    </div>
                                  </FormText>
                                }
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-companyuin-input9">
                                  District
                                </Label><span className="text-danger">*</span>
                                <Input
                                  id="basicpill-companyuin-input9"
                                  className="form-control"
                                  type="text"
                                  name="district"
                                  placeholder="Enter District"
                                  onChange={handleInputChange2}
                                  disabled={!isOrgAdmin}
                                  value={user.district}
                                  invalid={form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.district}
                                />
                                <FormFeedback>
                                  {form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.district}
                                </FormFeedback>
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-declaration-input10">
                                  Town<span className="text-danger">*</span>
                                </Label>
                                <Input
                                  id="basicpill-Declaration-input10"
                                  className="form-control"
                                  type="text"
                                  name="town"
                                  placeholder="Enter Town"
                                  onChange={handleInputChange2}
                                  value={user.town}
                                  disabled={!isOrgAdmin}
                                  invalid={form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.town}
                                />
                                <FormFeedback>
                                  {form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.town}
                                </FormFeedback>
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-declaration-input10">
                                  Zip
                                </Label><span className="text-danger">*</span>
                                <Input
                                  id="basicpill-Declaration-input10"
                                  className="form-control"
                                  type="text"
                                  name="zip"
                                  placeholder="Enter Zip"
                                  onChange={handleInputChange2}
                                  value={user.zip}
                                  disabled={!isOrgAdmin}
                                  invalid={form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.zip}
                                />
                                <FormFeedback>
                                  {form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.zip}
                                </FormFeedback>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </TabPane>}
                    <TabPane tabId={isOrgAdmin ? 3 : 2}>
                      <div>
                        <Form>
                          <Row>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label>User Account Status</Label>
                                <p>You can active or inactive the user.</p>
                                <ul className="form-unstyled-list form-status-list mt-2">
                                  <li
                                    onClick={handleNotificationStatusChange}
                                    className={`form-status-item ${!user.isActive ? "active" : ""}`}
                                  >
                                    Inactive
                                  </li>
                                  <li
                                    onClick={handleNotificationStatusChange}
                                    className={`form-status-item ${user.isActive ? "active" : ""}`}
                                  >
                                    Active
                                  </li>
                                </ul>
                              </FormGroup>
                            </Col>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label>User Activation Status</Label>
                                <p>You can enable or disable the user.</p>
                                <ul className="form-unstyled-list form-status-list mt-2">
                                  <li
                                    onClick={handleActivationStatusChange}
                                    className={`form-status-item ${!user.isEnabled ? "active" : ""}`}
                                  >
                                    Disabled
                                  </li>
                                  <li
                                    onClick={handleActivationStatusChange}
                                    className={`form-status-item ${user.isEnabled ? "active" : ""}`}
                                  >
                                    Enabled
                                  </li>
                                </ul>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label>Lock/Unlock Account</Label>
                                <p>You can lock or unlock the user account.</p>
                                <ul className="form-unstyled-list form-status-list mt-2">
                                  <li
                                    onClick={handleLockStatusChange}
                                    className={`form-status-item ${user.isLocked ? "active" : ""}`}
                                  >
                                    Lock
                                  </li>
                                  <li
                                    onClick={handleLockStatusChange}
                                    className={`form-status-item ${!user.isLocked ? "active" : ""}`}
                                  >
                                    Unlock
                                  </li>
                                </ul>
                              </FormGroup>
                            </Col>
                            {(isSuperAdmin && (userDetails && userDetails.roleKey === "OrgAdmin")) &&
                              <Col lg='6'>
                                <FormGroup>
                                  <Label>
                                    Allowed Roles To Be Created By Organization Admin
                                  </Label>
                                  <Select
                                    styles={customStyle}
                                    isMulti
                                    isSearchable
                                    placeholder='Select role'
                                    options={ROLE_PERMISSION_ORG_ADMIN}
                                    onChange={handleRolePermission}
                                    value={selectedRolePermission}
                                  />
                                  <FormText> <strong>Note : </strong>Organization admin will be able to create only the selected role users.</FormText>
                                </FormGroup>
                              </Col>}
                          </Row>
                        </Form>
                      </div>
                    </TabPane>
                    <TabPane tabId={isOrgAdmin ? 4 : 3}>
                      <Row className="justify-content-center">
                        <Col lg="12">
                          {isPending ? <VWLoading />
                            : <div className="text-center">
                              <div className="mb-4">
                                <i className="mdi mdi-check-circle-outline text-success display-4" />
                              </div>
                              <div>
                                <h5>Confirm Details</h5>
                                <p className="text-muted">
                                  The user details are going to update. Are you sure to update?
                                </p>
                              </div>
                              <Button color="success" onClick={handleSubmit}>
                                Submit
                              </Button>
                              <Link className="btn btn-danger ms-4" to={`/userlist/details/${user.id}`}>
                                Cancel
                              </Link>
                            </div>}
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                  <ul className="pager wizard twitter-bs-wizard-pager-link">
                    <li className={activeTabwiz === 1 ? "previous disabled me-2" : "previous me-2"}>
                      {activeTabwiz !== 1 && <Button
                        color='primary'
                        onClick={() => toggleTabwiz(activeTabwiz - 1)}
                        disabled={activeTabwiz === 1}>
                        Previous
                      </Button>}
                    </li>
                    <li className={isOrgAdmin ? activeTabwiz === 4 ? "next disabled" : "next" : activeTabwiz === 3 ? "next disabled" : "next"}>
                      {(isOrgAdmin ? activeTabwiz !== 4 : activeTabwiz !== 3) && <Button
                        color='primary'
                        onClick={() => toggleTabwiz(activeTabwiz + 1)}
                        disabled={isOrgAdmin ? activeTabwiz === 4 : activeTabwiz === 3}>
                        Next
                      </Button>
                      }
                    </li>
                  </ul>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <VWModel
          header="ADD ZONE"
          isOpen={props.isCreateZoneModalOpen}
          handleClose={handleClose}
        >
          <AddZone handleClose={handleClose} />
        </VWModel>

      </div>
    </React.Fragment >
  );
};

const mapStateToProps = (state) => ({
  isCreateZoneModalOpen: state.zones.isCreateZoneModalOpen,
  isPending: state.userdetails.isUpdateUserPending,
  isSuccess: state.userdetails.isUpdatedSuccess,
  errorMessage: state.userdetails.updateUserErrorMessage,
  currentProfile: state.login.currentProfile,
  userDetails: state.userdetails.userDetails,
  form: state.form.form,
});

const mapDispatchToProps = (dispatch) => ({
  openCreateZoneModal: () => dispatch(openCreateZoneModal()),
  closeCreateZoneModal: () => dispatch(closeCreateZoneModal()),
  updateForm: (AddOrganisation) => dispatch(updateForm(AddOrganisation)),
  clearForm: () => dispatch(clearForm()),
  clearUpdateUserError: () => dispatch(clearUpdateUserError()),
  updateUser: (user) => dispatch(updateUser(user)),
  getAssignableZonesForAsyncSelect: (searchValue, callback) => dispatch(getAssignableZonesForAsyncSelect(searchValue, callback)),
  getFilteredStatesForAsyncSelect: (searchValue, callback) => dispatch(getFilteredStatesForAsyncSelect(searchValue, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormWizard);
